import React from 'react'
import { ChatBreakoutSquare, CommandIcon, MessageChatCircle, MessageHeartIcon, MessageSmileCircle, Zap } from '../../../Icons'

const FeatureCard = ({ icon, title, detail }) => {
    return (
        <div className="flex flex-col gap-[20px] w-full items-center">
            <div className="flex items-center justify-center p-[12px] rounded-[10px] border-[1px] border-[#EAECF0] w-fit">
                {icon}
            </div>
            <div className="flex flex-col gap-[8px] items-center">
                <span className='text-[#101828] text-[20px] font-bold text-center'>
                    {title}
                </span>
                <p className='text-[16px] text-[#475467] text-center'>
                    {detail}
                </p>
            </div>
        </div>
    )
}

const FeatureSection = () => {
    return (
        <div className='flex flex-col py-[96px]  gap-[64px] items-center max-2xl:px-[7.7vw] max-w-[1600px]'>
            <div className="flex flex-col gap-[20px] items-center max-w-[768px]">
                <div className="flex flex-col gap-[12px] items-center">
                    <span className='text-[#F02E49] font-[600] text-center'>
                        Features
                    </span>
                    <h2 className='text-[#101828] sm:text-[36px] text-[32px] font-[600] text-center'>
                        Amplify Your Experience: Unmatched Benefits for Event Planners
                    </h2>
                </div>
                <span className='text-[#475467] sm:text-[20px] text-[16px] text-center'>
                    Craft the Perfect Event: Exclusive Access to World-Class DJs and Stress-Free Planning.
                </span>
            </div>
            <div className="grid lg:grid-cols-3 gap-[32px] md:grid-cols-2 grid-cols-1">
                <FeatureCard icon={<MessageChatCircle iconColor={'#344054'} />} title={'Discover Your Perfect Match'} detail={'Browse through a handpicked roster of talented DJs. Find the perfect fit for your event’s vibe and genre preferences.'} />
                <FeatureCard icon={<Zap className={''} iconColor={'#344054'} />} title={'Book with Ease, Party with Peace'} detail={'Our streamlined booking process means you can secure your DJ in just a few clicks, leaving you more time to enjoy the anticipation of your event.'} />
                <FeatureCard icon={<ChatBreakoutSquare iconColor={'#344054'} />} title={'Transparent Pricing'} detail={'With clear, upfront pricing, you’ll know exactly what you’re paying for. No hidden fees, no last-minute charges.'} />
                <FeatureCard icon={<MessageSmileCircle iconColor={'#344054'} />} title={'Craft Your Unique Event Experience'} detail={'Personalize your event with our customization options. Whether it’s a specific playlist or a unique performance style, we make it happen.'} />
                <FeatureCard icon={<CommandIcon className={'!w-[24px] !h-[24px]'} iconColor={'#344054'} />} title={' Safe Transactions'} detail={'Our secure payment system ensures that your financial details are protected, so you can focus on the events, not the bills.'} />
                <FeatureCard icon={<MessageHeartIcon iconColor={'#344054'} />} title={' 24/7 Support'} detail={'Our dedicated support team is available around the clock to assist with any questions or concerns, ensuring your experience is as smooth as the mixes.'} />
            </div>
        </div>
    )
}

export default FeatureSection